<template>
  <div class="partner-container" id="partner">
    <Title ch="合作伙伴" :bg-img="titleBgImg"></Title>
    <div class="partner-content">
      <div class="partner-box">
        <div
          class="partner-item"
          @mouseleave="hoverPartner(item)"
          v-for="(item, index) in list"
          :key="index"
        >
          <img :src="item.coverImageRealPath_new" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "./common/Title";
import { $config } from "@/conf";

export default {
  name: "Partner",
  data() {
    return {
      titleBgImg: require("../assets/images/wap/title/partner.png"),
      list: [],
    };
  },
  components: {
    Title,
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.list = [];
      this.$api.getPartnerList(this.$config.partnerId).then((res) => {
        let lists = res.content.items;
        lists.forEach((item) => {
          item.coverImageRealPath_new = "";
          if (item.coverImageRealPath) {
            item.coverImageRealPath_new = item.coverImageRealPath.replace(
              /^.*\/\/hwyhw.smarket.net.cn/,
              "https://hwyhw-files.smarket.net.cn"
            );
          }
        });
        this.list = lists.sort((a, b) => {
          return b.order - a.order;
        });
        this.$bus.$emit("ready", "partner");
      });
    },
    //合作伙伴 埋码
    hoverPartner(item) {
      //埋码
      window._hw("send", "action", "index_partner_click", {
        partner_name: item.title,
        partner_type: "",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
//MOBILE
@media screen and (max-width: 992px) {
  .partner-container {
    padding: 148px 35px 63px;
    width: 100%;
    .partner-content {
      height: 604px;
      padding: 20px 10px;
      width: 100%;
      background: rgba(255, 255, 255, 0.22);
      border: 1px solid;
      border-image: linear-gradient(
          160deg,
          rgba(255, 255, 255, 1),
          rgba(235, 235, 235, 0),
          rgba(235, 235, 235, 0),
          rgba(255, 255, 255, 0.62)
        )
        2 2;

      ::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }

      ::-webkit-scrollbar-thumb {
        border-radius: 10px;
      }

      ::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 10px;
      }

      .partner-box {
        padding-top: 40px;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;

        .partner-item {
          width: calc(100% / 3);
          overflow: hidden;
          padding-bottom: 80px;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 130px;
          }
        }
      }
    }
  }
}

//PC
@media screen and (min-width: 992px) {
  .partner-container {
    padding: 60px 160px 60px 160px;
    .partner-content {
      height: 423px;
      padding: 20px 10px;
      width: 100%;
      background: rgba(255, 255, 255, 0.22);
      border: 1px solid;
      border-image: linear-gradient(
          160deg,
          rgba(255, 255, 255, 1),
          rgba(235, 235, 235, 0),
          rgba(235, 235, 235, 0),
          rgba(255, 255, 255, 0.62)
        )
        2 2;

      ::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }

      ::-webkit-scrollbar-thumb {
        border-radius: 10px;
      }

      ::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 10px;
      }

      .partner-box {
        padding-top: 40px;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;

        .partner-item {
          width: calc(100% / 6 - 22px);
          height: 80px;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 30px;
          margin-left: 10px;
          margin-right: 10px;

          img {
            width: 150px;
            flex-shrink: 0;
            &:hover {
              width: 180px;
            }
          }
        }
        @media screen and (-ms-high-contrast: active),
          (-ms-high-contrast: none) {
          /*兼容IE11*/
          .partner-item {
            width: 225px;
            overflow: hidden;
            margin-bottom: 30px;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            height: 80px;

            img {
              width: 150px;
              flex-shrink: 0;
              &:hover {
                width: 180px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
